import { createSlotRecipe } from './runtime';

const menuConfig = {"name":"menu","slots":["content","list","item","icon","label","divider","group","groupTitle","itemIndicator"]}

export const menu = /* @__PURE__ */ createSlotRecipe(menuConfig)